import { AsyncPipe, NgClass } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@spartacus/core';
import { Observable } from 'rxjs';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';

@Component({
  selector: 'app-confirmation-personal-info',
  templateUrl: './confirmation-personal-info.component.html',
  styleUrls: ['./confirmation-personal-info.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [NgClass, MatIcon, AsyncPipe, TranslatePipe],
})
export class ConfirmationPersonalInfoComponent implements OnInit {
  activeLanguage$: Observable<string> = this.languageService.getActive();

  constructor(protected modalService: StandardModalService, private languageService: ShimanoLanguageService) {}

  ngOnInit() {}

  confirmPersonalInfo() {
    this.modalService.closeDialog({ isTriggered: true });
  }

  closeModal(info?: any) {
    this.modalService.closeDialog(info);
  }
}
